import { useGraphMutation, useToast } from "@dashboard/library";
import { useTranslation } from "react-i18next";

import { DeleteEvaluationMutationVariables } from "@/graphql/generated/graphql";
import { DeleteEvaluationMutation } from "@/graphql/mutations/DeleteEvaluation";

export function useDeleteEvaluation() {
  const { t } = useTranslation();

  const { show } = useToast();

  const [deleteMutation, { loading }] = useGraphMutation(
    DeleteEvaluationMutation,
    {
      update(cache, { data }) {
        if (data?.deleteEvaluation.__typename === "DeleteEvaluation") {
          /**
           * We remove the evaluation through the cache
           * to avoid having to refetch the query.
           *
           * More info here: https://www.apollographql.com/docs/react/data/mutations/#refetching-queries
           */
          cache.evict({
            id: cache.identify({
              __typename: "Evaluation",
              ID: data.deleteEvaluation.ID,
            }),
          });
          cache.gc();
        }
      },
      onCompleted() {
        show({
          message: t("evaluation.deleted"),
          variant: "success",
        });
      },
      onError(e) {
        show({
          variant: "critical",
          message: e.message,
        });
      },
    }
  );

  const deleteEvaluation = async ({
    callID,
  }: DeleteEvaluationMutationVariables) => {
    await deleteMutation({
      variables: {
        callID,
      },
    });
  };

  return {
    deleteEvaluation,
    loadingDeleteEvaluation: loading,
  };
}
